import { FloatingFormItem } from '@/components/_common';
import EmployeesSelectedModal from '@/components/_common/EmployeesSelectedModal';
import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';
import { DeliveryOfMaterialFormValues } from '@/core/domain/reports/stock/DeliveryOfmaterial/DeliveryOfmaterial.types';
import { useDisclosure } from '@/hooks';
import {
  Badge,
  Button,
  Col,
  Collapse,
  Form,
  FormInstance,
  Input,
  Row,
} from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<DeliveryOfMaterialFormValues & ReportDateInterface>;
}

const DeliveryOfMaterialMoreOptions = ({ form }: Props) => {
  const intl = useIntl().formatMessage;
  const [employeeModal, employeeModalActions] = useDisclosure();

  return (
    <Collapse>
      <Collapse.Panel
        key={1}
        header={intl({ id: 'stock.DeliveryOdMaterial.form.moreOptions' })}
      >
        <Row gutter={[24, 24]}>
          <Col xs={12}>
            <FloatingFormItem
              name="osFilter"
              label={intl({
                id: 'stock.DeliveryOdMaterial.form.moreOptions.filterByBudget',
              })}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col xs={12}>
            <Form.Item noStyle name="employeesIds" hidden />

            <Badge count={form.getFieldValue('employeesIds')?.length}>
              <Button onClick={employeeModalActions.open} type="primary">
                Selecionar Funcionários
              </Button>
            </Badge>

            <EmployeesSelectedModal
              handleVisible={employeeModalActions.close}
              visible={employeeModal}
              finishCallback={(e) => form.setFieldValue('employeesIds', e)}
              selectedEmployeesIds={form.getFieldValue('employeesIds')}
            />
          </Col>
        </Row>
      </Collapse.Panel>
    </Collapse>
  );
};

export default DeliveryOfMaterialMoreOptions;
